import { useEffect, useState } from 'react';
import { Card } from 'primereact/card';
import api from '../../services/api'; // Asegúrate de que la ruta sea correcta

export default function DashboardPage() {
    const [portPages, setPortPages] = useState([]);

    useEffect(() => {
        api.get('/entry_pages') // Nota que no necesitas la URL completa
            .then(response => {
            setPortPages(response.data);
            })
            .catch(error => {
            console.error('Error fetching port pages:', error);

            // Manejo adicional de errores (opcional)
            if (error.response?.status === 401) {
                // Token inválido o expirado
                console.log('Sesión expirada, redirigiendo...');
                // Ejemplo: localStorage.removeItem('authToken');
                // Ejemplo: redirigir a login
            }
            });
    }, []);

    return (
        <div className="grid">
            <div className="col-12 md:col-12 lg:col-12">
            </div>
            <div className="col-12 md:col-6 lg:col-3">
                <h2>
                    Dashboard
                </h2>
                <Card
                    style={{
                        minHeight: '200px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        background: 'linear-gradient(to right, #2020A0, #3b82f6)', // Slow blue gradient
                        color: 'white',
                        boxShadow: '0 4px 14px rgba(0, 0, 0, 0.1)',
                        borderRadius: '1rem',
                        padding: '1.5rem'
                    }}
                >
                    <div className="flex justify-content-between align-items-start">
                        <div>
                            <h4 style={{ margin: 0 }}>Active Routes</h4>
                            <p className="mt-2 mb-0" style={{ fontSize: '2.5rem', fontWeight: 'bold' }}>
                                {<span> {portPages.length}</span>}
                            </p>
                        </div>
                        <i className="pi pi-map-marker" style={{ fontSize: '2rem', opacity: 0.2 }} />
                    </div>
                </Card>
            </div>
        </div>
    );
}
